import { connect } from 'react-redux';
import WidgetContainer from '../WidgetContainer/WidgetContainer';
import { getLocale, addGAEventTracking } from '!/common/helpers';


const Categories = props => {
  const { categories, categoryPath, q, className } = props;
  const renderFullTree = q === undefined;
  if (!categories) {
    return null;
  }

  const renderList = (categories, open, idx = 0) => (
    <ul className="category-tree__root" aria-hidden={open ? 'false' : 'true'}>
      {categories.map((category, index) => (
        <li
          key={category.id}
          className={`category-tree__item${
            categoryPath[categoryPath.length - 1] === category.id ? ' category-tree__item--active' : ''
            }${!renderFullTree && idx++ > 9 ? ' category-tree__item--ondemand' : ''}`}
        >
          <a href={`/${category.url}`} {...addGAEventTracking('Category Click', 'Search Filter', category.name.replace(/ *\([^)]*\) */g, ""))}>{category.name}</a>
          {category.children && renderList(category.children, categoryPath.indexOf(category.id) > -1, index)}
        </li>
      ))}
    </ul>
  );

  return (
    <WidgetContainer
      className={className || ''} 
      open={true}
      title={`${!renderFullTree ? 'in ' : ''} ${getLocale('Category')}`}
      showUtils={categories.length > 9 && !renderFullTree}
      name="categories"
    >
      <div className="category-tree">{renderList(renderFullTree ? categories : categories, true)}</div>
    </WidgetContainer>
  );
};

export default connect(({ categories, categoryPath, hits, q }) => ({ categories, categoryPath, hits, q }))(Categories);
